import nativeApi from '../utils/native-api';
import env       from '../utils/env.js';

import API from '../api'
import {
  get
} from '../utils/index'
import localStorage from '../utils/localStorage'

export default {
  login({callback = null}={}) {
    return nativeApi.invoke('login').then(r => {
      if (r.value !== r.SUCC) { // 安卓上会有回调，判断登录是否成功
        console.warn('native login() fail');
        throw {
          platform: 'app',
          name: 'NativeLoginFail',
          message: '登录失败'
        };
      }
      else {
        if (callback) {
          return callback()
        }
      }
    }, e => {
      console.warn('native login() fail:', e);
      throw {
        platform: 'app',
        name: 'NativeLoginFail',
        message: '登录失败'
      };
    });
  },

  logout() {
    this.clearStorage()
    return Promise.resolve()
  },

  getToken() {
    // 为了保证跟app登录状态保持一致，每次都要重新调用getUserInfo
    return nativeApi.invoke('getUserInfo', {
      appName: env.appName || 'hbgj'
    }).then(r => {
      r = r || {};
      if (r.h5authcode) {
        return {
          authcode: r.h5authcode
        };
      } else if (r.authcode) {
        let lAuthCode = r.authcode;
        return API.login['41216'](r.authcode).then(r => {
          console.log('41216 r: ', r)
          let code = get(r, 'res.hd.code')
          if (code === 1) {
            let bd = get(r, 'res.bd')
            this.saveLoginDate(bd)
            return {
              authcode: bd.authcode
            }
          }
        }).catch(() => {
          return {
            authcode: lAuthCode
          }
        })
      } else {
        console.error('getUserInfo fail:', r);
        // throw new Error('程序异常');
        throw {
          name: 'AuthError',
          message: '获取用户信息失败'
        };
      }
    }).catch(() => {
      // TODO: 还得进一步判断是否是未登录，也可能是客户端网络请求错误
      throw {
        name: 'AuthError',
        message: '获取用户信息失败'
      };
    });
  },

  // 客户端上刷新跟获取是一样的
  refreshToken() {
    this.clearStorage();
    return this.getToken();
  },

  saveLoginDate(r) {
    localStorage.set("authcode", r.authcode);
    localStorage.set("refreshcode", r.refreshcode);
    localStorage.set("authExpiretime", r.authExpiretime);
    localStorage.set("refreshExpiretime", r.refreshExpiretime);
    localStorage.set("user", r.user);
  },

  clearStorage() {
    localStorage.remove('authcode')
    localStorage.remove('refreshcode')
    localStorage.remove('authExpiretime')
    localStorage.remove('refreshExpiretime')
    localStorage.remove('user')
  }
};



// WEBPACK FOOTER //
// ./src/auth/native.js